import FilteredEllipse from '@/assets/svg/Blur';
import HeadingOne from '@/components/ui/headings/HeadingOne';
import PartnersBanner from '@/components/screens/PartnersBanner';
import { useTranslation } from 'react-i18next';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { useEffect, useState } from 'react';
import { getApiBaseUrl, getStorageUrl } from '@/utils/utils';
import Loading from '@/components/ui/Loading';

interface Props {
    id: number;
    logo: string;
    title: string;
    image: string;
    description: string;
}

const Partners = () => {
    const { t } = useTranslation();
    const [activePartner, setActivePartner] = useState<Props | null>(null);
    const [parntersData, setparntersData] = useState<Props[]>([]);
    const [loading, setLoading] = useState(true);

    const [emblaRef, emblaApi] = useEmblaCarousel(
        {
            align: 'start',
            slidesToScroll: 1,
        },
        [Autoplay()],
    );

    const [selectedIndex, setSelectedIndex] = useState(0);

    const onSelect = () => {
        if (!emblaApi) return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
    };

    useEffect(() => {
        if (!emblaApi) return;
        emblaApi.on('select', onSelect);
        onSelect();
    }, [emblaApi]);

    useEffect(() => {
        setLoading(true);
        fetch(`${getApiBaseUrl()}/partners`)
            .then((response) => response.json())
            .then((res) => {
                const data = res.data;
                setparntersData(data);
                if (data.length > 0) {
                    setActivePartner(data[0]);
                }
            })
            .catch((error) => console.error('Error fetching Partners:', error))
            .finally(() => setLoading(false));
    }, []);

    const handleClick = (partner: Props) => {
        setActivePartner(partner);
    };

    return (
        <div className="w-full h-full">
            <FilteredEllipse className="!top-[-11%] !left-[-27%] !w-[1140px] !h-[850px]" />
            <div className="mainContainer flex flex-col h-full w-full">
                <div className="xl:mt-[155px] lg:mt-[140px] mt-[125px]">
                    <HeadingOne headOne={t('menu.partners')} className="text-center" />
                    <div className="embla" ref={emblaRef}>
                        <div className="embla__container-partner flex md:gap-[30px] justify-center mt-[32px] mb-[40px]">
                            {parntersData.map((e) => (
                                <div
                                    key={e?.id}
                                    onClick={() => handleClick(e)}
                                    className={`embla__slide-partner cursor-pointer w-[100px] h-[39px] flex items-center justify-center ${activePartner?.id === e?.id ? 'filterBlue' : 'filterWhite'}`}
                                >
                                    <img src={getStorageUrl(e?.logo)} className="md:w-[40px] sm:w-[30px] w-[24px]" />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Tabs */}
                    {loading ? (
                        <Loading className="my-10" />
                    ) : (
                        <PartnersBanner activePartner={activePartner as Props} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Partners;
